module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Purpose")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780062098979_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2b"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rded"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dedication")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpraise"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Epigraph#praise",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epigraph")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a",
    attrs: {
      "id": "rfrontmatter01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/text/9780062098979_Introduction#frontmatter01"
    }
  }, [_c('i', [_vm._v("Introduction: The Invisible Man")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rchapter01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/text/9780062098979_Chapter_1#chapter01"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" - "), _c('i', [_vm._v("The Village")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rchapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Chapter_2#chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" - "), _c('i', [_vm._v("Garden State Promised Land")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rchapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Chapter_3#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" - "), _c('i', [_vm._v("To the Beat of My Own Drum")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rchapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Chapter_4#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" - "), _c('i', [_vm._v("Three Become One")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rchapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Chapter_5#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" - "), _c('i', [_vm._v("The Score")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rchapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Chapter_6#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" - "), _c('i', [_vm._v("Fugees on Fire")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rchapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Chapter_7#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v(" - "), _c('i', [_vm._v("When the Circle Broke")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rchapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Chapter_8#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" - "), _c('i', [_vm._v("Wyclef for President")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a",
    attrs: {
      "id": "rbackmatter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Conclusion#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Conclusion")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rbackmatter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Acknowledgments#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rata"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rphoto"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Photoinsert#photo",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Photo Insert")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rcredit"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Credits#credit",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Credits")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rcopy"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/9780062098979_Copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4214f037","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062098979_Contents.vue
// module id = 69
// module chunks = 0